import React from 'react'
import {Link} from 'react-router-dom'
const Program_card = () => {
  return (

    <>
    {/* -------------------------Mobile View---------------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
            <div className='row d-flex text-center'>
                <div className='col-md-12 Mobile_card my-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://plus.unsplash.com/premium_photo-1682124710157-d1573373a4f5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Artificial Intelligence</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Get started on an exciting new adventure in AI with our all-encompassing training program. This course will teach you all you need to know about deep learning, as well as the fundamentals of Python and data analysis with Pandas.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to='/AI'><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>

                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://plus.unsplash.com/premium_photo-1682124651258-410b25fa9dc0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1921&q=80"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Machine Learning</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                             <p className='text-center'>With our course, take a thorough exploration of the field of machine learning. Explore both supervised and unsupervised learning by starting with the fundamentals of Python and moving on to more complex algorithms like Linear Regression and Random Forests. </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/ML"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://images.pexels.com/photos/270404/pexels-photo-270404.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Web Development</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM manipulation, jQuery, Node.js, and database principles, you can start a whole web development journey. Explore complex ideas like React.js, Angular, Spring Boot, MongoDB, and Node.js, leading to </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/WD"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://images.unsplash.com/photo-1599658880436-c61792e70672?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Data Science</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals of Python, and refine your skills in data wrangling and visualization. Learn about the possibilities of deep learning, gain practical experience with BI tools, and develop </p>
                          </ul>
                          <div className='text-center'>
                          <Link to='/DS'><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>

      <div className='container'>
            <div className='row'>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/representations-user-experience-interface-design_23-2150038906.jpg?w=996&t=st=1696510295~exp=1696510895~hmac=2a890cf6dc383a4bb7b57ed5df6098c56a3d65b28c3b3100313a194db7391e4ahttps://img.freepik.com/free-photo/representations-user-experience-interface-design_23-2150038906.jpg?w=996&t=st=1696510295~exp=1696510895~hmac=2a890cf6dc383a4bb7b57ed5df6098c56a3d65b28c3b3100313a194db7391e4a"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Android App Development</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                             <p className='text-center'>Embark on a dynamic journey into Android development with our comprehensive Training Internship. Delve into live projects guided by industry experts, covering the entire Android development spectrum. From foundational concepts to advanced Flutter applications, gain </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/AAD"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/humanoid-robot-working-with-machine-factory-ai-generative_123827-23864.jpg?w=996&t=st=1696510345~exp=1696510945~hmac=525a80e08dfdc959bc1f65b86f68e6d3cecab10085073280c8d21501255a41fd"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Robotics</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our extensive course, take a revolutionary step into the world of robotics. Explore the laws, types, and components of robot design as you delve into its complexities. Master the ATmega 328p microcontroller to integrate sensors and actuators. Learn how to program </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/RO"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-vector/cyber-security-concept_23-2148532223.jpg?w=996&t=st=1696510194~exp=1696510794~hmac=fc80afa492fe5a3923c5d2f6b84e7bc808b524fbb172bc3d6618ff1f3d7cb05f"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Cyber Security</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical hacking principles, dive into the world of cybersecurity. Examine techniques for scanning and reconnaissance, web server security, SQL injection, malware </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/CS"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/saas-concept-collage_23-2149399281.jpg?w=996&t=st=1696510112~exp=1696510712~hmac=467c443348013370c5142ad6935a6adaca56cbd5bee3e8ab8c66af5875af263e"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Cloud Computing</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Discover the ever-changing realm of cloud computing with our all-inclusive course! Learn about Azure services, have a thorough understanding of Cloud Fundamentals, and become an expert in networking. Gain real experience with projects that range from Azure</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/CC"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>

      <div className='container'>
            <div className='row'>
                <div className='col-md-12 Mobile_card my-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/human-resources-concept-with-hand_23-2150389117.jpg?w=996&t=st=1696510461~exp=1696511061~hmac=8334430af676dd8c392cffd1c32ddcca2a1ee3b13028aaccb2baad97952c58d6"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Human Resource</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                            <p className='text-center'>In-depth study of Human Resource Management (HRM) will be provided in this course. Examine all aspects of HR, including performance management and recruiting and selection, with an emphasis on current issues and emerging trends. Acquire vital skills in employee </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/HR"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/front-view-arrangement-economy-elements_23-2148793796.jpg?w=1060&t=st=1696510497~exp=1696511097~hmac=c6fa4ee76ab47291df8291f5841de0346bafd7428efd529447a2e376b5f92d6a"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Finance</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our extensive curriculum that covers Treasury duties, Corporate Finance, Portfolio Management, Financial Risk Management, and useful tools like Cash and Liquidity Management, you may discover the exciting world of finance. Explore the complexities of the </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/FA"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/businesspeople-meeting-plan-analysis-graph-company-finance-strat_74952-1400.jpg?w=1380&t=st=1696510535~exp=1696511135~hmac=f897dc59d7f3201977b8875edb031d52f373f5012dcbf73b96aabce2099a2716"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Business Analytics</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our in-depth training, you can enter the exciting field of Business Analytics. Gain familiarity with Python while studying statistics and visualising data. Learn about databases including SQL, NoSQL, and Spark, as well as other data science technologies. Learn to use </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/BA"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/image-engineering-objects-workplace-top-view-construction-concept-engineering-tools-vintage-tone-retro-filter-effect-soft-focus-selective-focus_1418-704.jpg?w=996&t=st=1696510392~exp=1696510992~hmac=169fab03644017ef91089beb8fe337f1545a9ad79a3a31f8ef57ce0b8a08115f"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>AutoCAD</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Learn AutoCAD from the ground up with our engaging course materials. Our training covers all the bases, from geometry creation and advanced features to parametric restrictions and dynamic blocks. Dive into AutoCAD 2023, studying its user interfaces and advanced </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/AC"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>

      <div className='container'>
            <div className='row'>
                <div className='col-md-12 Mobile_card my-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/hands-holding-smartphone-social-media-concept_23-2150208239.jpg?w=996&t=st=1696510625~exp=1696511225~hmac=ef600a1760bb798eae356849052036e5ed6cf4aabb35e5dd46539d338e85b60d"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Digital Marketing</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Take a deep dive into the exciting world of marketing management and digital marketing. This course covers everything from comprehending consumer behavior to becoming an expert in SEO, SMM, and paid advertising across a range of platforms. Explore the potential </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/DM"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                
                <div className='col-md-12 Mobile_card my-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/technician-repairing-computer-computer-hardware-repairing-upgrade-technology_1150-8861.jpg?w=996&t=st=1707462256~exp=1707462856~hmac=82e8d4ccc020406102d664e3d04611520929d6bd675255fc97d45330ac7d7eb9"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>VLSI</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>VLSI technology has revolutionized the electronics industry by enabling the development of increasingly complex and powerful integrated circuits. It continues to drive innovation and shape the future of electronics through advancements in design methodologies, manufacturing processes, and emerging technologies.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/VLSI"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>

                <div className='col-md-12 Mobile_card my-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/futuristic-smart-city-with-5g-global-network-technology_53876-98438.jpg?size=626&ext=jpg&ga=GA1.1.136231225.1692439350&semt=sph"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>IOT</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>IoT has the potential to revolutionize industries, enhance connectivity, and drive innovation by enabling smarter, more efficient systems and services. However, addressing challenges such as security, interoperability, and privacy will be crucial for realizing the full potential of IoT in the future.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/IOT"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>

                <div className='col-md-12 Mobile_card my-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-vector/realistic-microchip-processor-background_52683-58133.jpg?size=626&ext=jpg&ga=GA1.1.136231225.1692439350&semt=ais"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Embedded System</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>embedded systems play a crucial role in modern technology, enabling the functionality of countless devices and systems in a wide range of industries and applications. They continue to evolve with advancements in hardware, software, and connectivity, driving innovation and shaping the future of technology.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/ES"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>
    </div>


    {/* ----------------------Desktop View------------------------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
            <div className='row '>
                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://plus.unsplash.com/premium_photo-1682124710157-d1573373a4f5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Artificial Intelligence</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Get started on an exciting new adventure in AI with our all-encompassing training program. This course will teach you all you need to know about deep learning, as well as the fundamentals of Python and data analysis with Pandas.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to='/AI'><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>

                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://plus.unsplash.com/premium_photo-1682124651258-410b25fa9dc0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1921&q=80"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Machine Learning</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                             <p className='text-center'>With our course, take a thorough exploration of the field of machine learning. Explore both supervised and unsupervised learning by starting with the fundamentals of Python and moving on to more complex algorithms like Linear Regression and Random Forests. </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/ML"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://images.pexels.com/photos/270404/pexels-photo-270404.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Web Development</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM manipulation, jQuery, Node.js, and database principles, you can start a whole web development journey. Explore complex ideas like React.js, Angular, Spring Boot, MongoDB, and Node.js, leading to</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/WD"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://images.unsplash.com/photo-1599658880436-c61792e70672?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Data Science</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals of Python, and refine your skills in data wrangling and visualization. Learn about the possibilities of deep learning, gain practical experience with BI tools, and develop web apps</p>
                          </ul>
                          <div className='text-center'>
                          <Link to='/DS'><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>

      <div className='container my-5'>
            <div className='row'>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/representations-user-experience-interface-design_23-2150038906.jpg?w=996&t=st=1696510295~exp=1696510895~hmac=2a890cf6dc383a4bb7b57ed5df6098c56a3d65b28c3b3100313a194db7391e4ahttps://img.freepik.com/free-photo/representations-user-experience-interface-design_23-2150038906.jpg?w=996&t=st=1696510295~exp=1696510895~hmac=2a890cf6dc383a4bb7b57ed5df6098c56a3d65b28c3b3100313a194db7391e4a"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Android App Development</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                             <p className='text-center'>Embark on a dynamic journey into Android development with our comprehensive Training Internship. Delve into live projects guided by industry experts, covering the entire Android development spectrum. From foundational concepts to advanced Flutter applications, gain </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/AAD"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/humanoid-robot-working-with-machine-factory-ai-generative_123827-23864.jpg?w=996&t=st=1696510345~exp=1696510945~hmac=525a80e08dfdc959bc1f65b86f68e6d3cecab10085073280c8d21501255a41fd"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Robotics</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our extensive course, take a revolutionary step into the world of robotics. Explore the laws, types, and components of robot design as you delve into its complexities. Master the ATmega 328p microcontroller to integrate sensors and actuators. Learn how to program</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/RO"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-vector/cyber-security-concept_23-2148532223.jpg?w=996&t=st=1696510194~exp=1696510794~hmac=fc80afa492fe5a3923c5d2f6b84e7bc808b524fbb172bc3d6618ff1f3d7cb05f"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Cyber Security</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical hacking principles, dive into the world of cybersecurity. Examine techniques for scanning and reconnaissance, web server security, SQL injection, malware </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/CS"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/saas-concept-collage_23-2149399281.jpg?w=996&t=st=1696510112~exp=1696510712~hmac=467c443348013370c5142ad6935a6adaca56cbd5bee3e8ab8c66af5875af263e"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Cloud Computing</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                            <p className='text-center'>Discover the ever-changing realm of cloud computing with our all-inclusive course! Learn about Azure services, have a thorough understanding of Cloud Fundamentals, and become an expert in networking. Gain real experience with projects that range from Azure</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/CC"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>

      <div className='container'>
            <div className='row'>
                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/human-resources-concept-with-hand_23-2150389117.jpg?w=996&t=st=1696510461~exp=1696511061~hmac=8334430af676dd8c392cffd1c32ddcca2a1ee3b13028aaccb2baad97952c58d6"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Human Resource</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                            <p className='text-center'>In-depth study of Human Resource Management (HRM) will be provided in this course. Examine all aspects of HR, including performance management and recruiting and selection, with an emphasis on current issues and emerging trends. Acquire vital skills in employee </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/HR"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/front-view-arrangement-economy-elements_23-2148793796.jpg?w=1060&t=st=1696510497~exp=1696511097~hmac=c6fa4ee76ab47291df8291f5841de0346bafd7428efd529447a2e376b5f92d6a"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Finance</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our extensive curriculum that covers Treasury duties, Corporate Finance, Portfolio Management, Financial Risk Management, and useful tools like Cash and Liquidity Management, you may discover the exciting world of finance. Explore the complexities of the </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/FA"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/businesspeople-meeting-plan-analysis-graph-company-finance-strat_74952-1400.jpg?w=1380&t=st=1696510535~exp=1696511135~hmac=f897dc59d7f3201977b8875edb031d52f373f5012dcbf73b96aabce2099a2716"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Business Analytics</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With our in-depth training, you can enter the exciting field of Business Analytics. Gain familiarity with Python while studying statistics and visualising data. Learn about databases including SQL, NoSQL, and Spark, as well as other data science technologies. Learn to use </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/BA"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/image-engineering-objects-workplace-top-view-construction-concept-engineering-tools-vintage-tone-retro-filter-effect-soft-focus-selective-focus_1418-704.jpg?w=996&t=st=1696510392~exp=1696510992~hmac=169fab03644017ef91089beb8fe337f1545a9ad79a3a31f8ef57ce0b8a08115f"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>AutoCAD</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Learn AutoCAD from the ground up with our engaging course materials. Our training covers all the bases, from geometry creation and advanced features to parametric restrictions and dynamic blocks. Dive into AutoCAD 2023, studying its user interfaces and advanced </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/AC"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>

      <div className='container my-5'>
            <div className='row'>
                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/hands-holding-smartphone-social-media-concept_23-2150208239.jpg?w=996&t=st=1696510625~exp=1696511225~hmac=ef600a1760bb798eae356849052036e5ed6cf4aabb35e5dd46539d338e85b60d"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Digital Marketing</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Take a deep dive into the exciting world of marketing management and digital marketing. This course covers everything from comprehending consumer behavior to becoming an expert in SEO, SMM, and paid advertising across a range of platforms. Explore the potential </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/DM"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>

                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/technician-repairing-computer-computer-hardware-repairing-upgrade-technology_1150-8861.jpg?w=996&t=st=1707462256~exp=1707462856~hmac=82e8d4ccc020406102d664e3d04611520929d6bd675255fc97d45330ac7d7eb9"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>VLSI</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>VLSI technology has revolutionized the electronics industry by enabling the development of increasingly complex and powerful integrated circuits. It continues to drive innovation and shape the future of electronics through advancements in design methodologies, manufacturing processes, and emerging technologies.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/VLSI"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>

                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/futuristic-smart-city-with-5g-global-network-technology_53876-98438.jpg?size=626&ext=jpg&ga=GA1.1.136231225.1692439350&semt=sph"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>IOT</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>IoT has the potential to revolutionize industries, enhance connectivity, and drive innovation by enabling smarter, more efficient systems and services. However, addressing challenges such as security, interoperability, and privacy will be crucial for realizing the full potential of IoT in the future.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/IOT"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>

                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-vector/realistic-microchip-processor-background_52683-58133.jpg?size=626&ext=jpg&ga=GA1.1.136231225.1692439350&semt=ais"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Embedded System</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>embedded systems play a crucial role in modern technology, enabling the functionality of countless devices and systems in a wide range of industries and applications. They continue to evolve with advancements in hardware, software, and connectivity, driving innovation and shaping the future of technology.</p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/ES"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>
    </div>
    
    </>


    
  )
}


export default Program_card
